// firenase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDnl8ZvUpEyjClgwYSb5APcU24zY-X0H8U",
  authDomain: "ngl-cila.firebaseapp.com",
  databaseURL: "https://ngl-cila-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ngl-cila",
  storageBucket: "ngl-cila.firebasestorage.app",
  messagingSenderId: "1049554300483",
  appId: "1:1049554300483:web:a023e58e8c5a8969cc6ef6",
  measurementId: "G-54W482ES88"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
